export default {
	props: {
		extLabel: String, //work as label
		selectClass:{type:String, default:'v2'},
	},
	data(){
		return {
			dialog: false,
		}
	},
	watch: {
		//
	},
	computed:{
		//
	},
	methods: {
		onShowDDList(){
			this.dialog = true;
		},
		onHideDDList(){
			this.dialog = false;
		},
		onDialogToggle(){
			this.dialog = !this.dialog;
			this.$emit(this.dialog?'show':'hide');
		},
		onClickButtonOk(){
			this.onDialogToggle();
			this.$emit('click-ok');
		},
	},

	mounted(){
		window.addEventListener('click', (ev)=>{
			if(this.dialog && !this.$refs.qitDDLControl.contains(ev.target)){
				this.onDialogToggle();
			}
		});
	},
	template: `
<div ref="qitDDLControl" class="dropdown-list-control">
	<label v-if="extLabel" class="ext-label" @click="onDialogToggle">{{extLabel}}</label>
	<div :class="['styled-select no-select', selectClass]" @click="onDialogToggle">
		<span class="inner-text"><slot name="label">label</slot></span>
	</div>
	<div :class="['dropdown-list', dialog?'show':'']">
		<slot name="content">content</slot>
		<slot name="bottom" v-bind="{onClickButtonOk}">
			<div class="bottom">
					<button type="button" @click="onClickButtonOk">OK</button>
			</div>
		</slot>
	</div>
</div>
`,
}
